<template>
  <div style="border: 0px solid black; ; display:block">
    <div class="welcome" style="border: 0px solid red;">
      <div class="box-body">
        <div class="box box-success">
          <div class="box-body">
            <!--  -->
            <div class="col-md-12">
              <div class="panel with-nav-tabs panel-info">
                <div class="panel-heading">
                  <ul class="nav nav-tabs">
                    <li class="active" @click="onSelectTab(1)">
                      <a href="#tab1warning" data-toggle="tab">{{
                        $t("customization_table.smtp_title")
                      }}</a>
                    </li>
                    <li v-if="isSuperAdmin()" @click="onSelectTab(2)">
                      <a href="#tab2warning" data-toggle="tab">{{
                        $t("customization_table.media_title")
                      }}</a>
                    </li>
                    <li @click="onSelectTab(3)">
                      <a href="#tab3warning" data-toggle="tab">{{
                        $t("sidebar.projectsettings.project_smtp")
                      }}</a>
                    </li>
                  </ul>
                </div>
                <div class="panel-body">
                  <div class="tab-content">
                    <div class="tab-pane fade in active" id="tab1warning">
                      <b-card
                        no-body
                        class="mb-1"
                        v-if="isSuperAdmin()"
                      >
                        <b-card-header
                          header-tag="header"
                          class="p-1"
                          role="tab"
                        >
                          <b-button
                            block
                            v-b-toggle.accordion-1
                            variant="info"
                            >{{
                              $t("customization_table.smtp_server.title")
                            }}</b-button
                          >
                        </b-card-header>
                        <b-collapse
                          id="accordion-1"
                          visible
                          accordion="my-accordion"
                          role="tabpanel"
                        >
                          <b-card-body>
                            <div class="box-body">
                              <!-- <div class="row"> -->
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="title">{{
                                    $t(
                                      "customization_table.smtp_server.smtp_domain"
                                    )
                                  }}</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="smtp_server.smtp_domain"
                                    :placeholder="
                                      $t(
                                        'customization_table.smtp_server.smtp_domain'
                                      )
                                    "
                                  />
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="title">{{
                                    $t(
                                      "customization_table.smtp_server.smtp_project"
                                    )
                                  }}</label>
                                  <!-- <input
                                      type="text"
                                      class="form-control"
                                      v-model="smtp_server.smtp_domain"
                                      :placeholder="$t('customization_table.smtp_server.smtp_domain')"
                                    /> -->
                                  <select
                                    name=""
                                    id=""
                                    class="form-control"
                                    v-model="smtp_server.smtp_project"
                                  >
                                    <option
                                      v-for="(smtpProject,
                                      index) in smtpProjectList"
                                      :key="smtpProject + index"
                                      :value="smtpProject.id"
                                      >{{ smtpProject.project_name }}</option
                                    >
                                  </select>
                                </div>
                              </div>
                              <!-- </div> -->
                              <!-- <div class="row"> -->
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="title">{{
                                    $t(
                                      "customization_table.smtp_server.smtp_username"
                                    )
                                  }}</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="smtp_server.smtp_username"
                                    :placeholder="
                                      $t(
                                        'customization_table.smtp_server.smtp_username'
                                      )
                                    "
                                  />
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="title">{{
                                    $t(
                                      "customization_table.smtp_server.smtp_password"
                                    )
                                  }}</label>
                                  <!-- <input
                                      class="form-control"
                                      v-model="smtp_server.smtp_password"
                                      @input="validatePassword(smtp_server.smtp_password)"
                                      type="password"
                                      id="password"
                                      :placeholder="$t('customization_table.smtp_server.smtp_password')"
                                    />
                                    <span
                                      :class="{ password_length_count : valid_password_length, show_password_length : password_typed }"
                                      class="password_length"
                                    >{{ password_length }}</span>

                                    <div v-show="password_typed" class="lnu_container">
                                      <p
                                        :class="{ got_lowercase : contain_lowercase}"
                                      >{{$t('user.lowercase')}}</p>
                                      <p
                                        :class="{ got_number : contain_number }"
                                      >{{$t('user.digit')}}</p>
                                      <p
                                        :class="{ got_uppercase : contain_uppercase }"
                                      >{{$t('user.uppercase')}}</p>
                                    </div> -->
                                  <b-button
                                    class="form-control"
                                    variant="primary"
                                    @click="onShowModalChangePasswordSMTPServer"
                                    >{{
                                      $t("user.password_modal[0].title")
                                    }}</b-button
                                  >
                                </div>
                              </div>
                              <!-- </div> -->
                              <div class="box-footer" style="padding-bottom: 0">
                                <button
                                  type="button"
                                  class="btn btn-labeled btn-success pull-right"
                                  style="margin-right: 5px;"
                                  @click="onSave"
                                >
                                  <span class="btn-label">
                                    <i class="glyphicon glyphicon-ok"></i>
                                  </span>
                                  {{ $t("common.save") }}
                                </button>
                                <button
                                  type="button"
                                  class="btn btn-labeled btn-warning pull-right"
                                  style="margin-right: 5px;"
                                  @click="onCheckConnect"
                                >
                                  <span class="btn-label">
                                    <i class="glyphicon glyphicon-globe"></i>
                                  </span>
                                  {{ $t("common.connect") }}
                                </button>
                              </div>
                            </div>
                          </b-card-body>
                        </b-collapse>
                      </b-card>

                      <!-- SMTP Project -->
                      <div>
                        <b-card
                          no-body
                          class="mb-1"
                          v-if="show_smtp_project == showServerSetting.ShowInfo"
                        >
                          <b-card-header
                            header-tag="header"
                            class="p-1"
                            role="tab"
                          >
                            <b-button
                              block
                              v-b-toggle.accordion-2
                              variant="info"
                              >{{
                                $t("customization_table.smtp_project.title")
                              }}</b-button
                            >
                          </b-card-header>
                          <b-collapse
                            id="accordion-2"
                            accordion="my-accordion"
                            role="tabpanel"
                          >
                            <b-card-body>
                              <div class="box-body">
                                <!-- only superadmin -->
                                <div
                                  class="col-md-6"
                                  v-if="isSuperAdmin()"
                                >
                                  <div class="form-group">
                                    <label for="title">{{
                                      $t(
                                        "customization_table.smtp_project.project_name"
                                      )
                                    }}</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      v-model="smtp_project.project_name"
                                      :placeholder="
                                        $t(
                                          'customization_table.smtp_project.project_name'
                                        )
                                      "
                                    />
                                  </div>
                                </div>

                                <div class="col-md-6">
                                  <div class="form-group">
                                    <label for="title">{{
                                      $t(
                                        "customization_table.smtp_project.alias"
                                      )
                                    }}</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      v-model="smtp_project.alias"
                                      :placeholder="
                                        $t(
                                          'customization_table.smtp_project.alias'
                                        )
                                      "
                                    />
                                  </div>
                                </div>
                                <!-- only superadmin -->
                                <div
                                  class="col-md-12"
                                  v-if="isSuperAdmin()"
                                >
                                  <div class="form-group">
                                    <label for="title">{{
                                      $t(
                                        "customization_table.smtp_project.description"
                                      )
                                    }}</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      v-model="smtp_project.description"
                                      :placeholder="
                                        $t(
                                          'customization_table.smtp_project.description'
                                        )
                                      "
                                    />
                                  </div>
                                </div>

                                <div class="col-md-6">
                                  <div class="form-group">
                                    <label for="title">{{
                                      $t(
                                        "customization_table.smtp_project.page_size"
                                      )
                                    }}</label>
                                    <input
                                      type="number"
                                      class="form-control"
                                      v-model="smtp_project.page_size"
                                      :placeholder="
                                        $t(
                                          'customization_table.smtp_project.page_size'
                                        )
                                      "
                                    />
                                  </div>
                                </div>

                                <div class="col-md-12">
                                  <div class="form-group">
                                    <label for="title">{{
                                      $t(
                                        "customization_table.smtp_project.sub_content"
                                      )
                                    }}</label>
                                    <textarea
                                      rows="8"
                                      type="text"
                                      class="form-control"
                                      v-model="smtp_project.sub_content"
                                      :placeholder="
                                        $t(
                                          'customization_table.smtp_project.sub_content'
                                        )
                                      "
                                    />
                                  </div>
                                </div>
                                <div
                                  class="box-footer"
                                  style="padding-bottom: 0"
                                >
                                  <button
                                    type="button"
                                    class="btn btn-labeled btn-success pull-right"
                                    style="margin-right: 5px;"
                                    @click="onSave_SMTP_Project"
                                  >
                                    <span class="btn-label">
                                      <i class="glyphicon glyphicon-ok"></i>
                                    </span>
                                    {{ $t("common.save") }}
                                  </button>
                                </div>
                              </div>
                            </b-card-body>
                          </b-collapse>
                        </b-card>
                        <div v-else-if="notFoundProject">
                          <p style="color: red; text-align: center">
                            {{
                              $t(
                                "customization_table.smtp_server.notFoundProject"
                              )
                            }}
                          </p>
                        </div>
                        <div
                          v-else-if="
                            show_smtp_project == showServerSetting.ErrorLogin
                          "
                        >
                          <p
                            v-if="isSuperAdmin()"
                            style="color: red; text-align: center"
                          >
                            {{
                              $t(
                                "customization_table.smtp_server.info_incorrect"
                              )
                            }}
                          </p>
                          <p v-else style="color: red; text-align: center">
                            {{
                              $t(
                                "customization_table.smtp_server.info_incorrect_for_user"
                              )
                            }}
                          </p>
                        </div>
                        <div v-else>
                          <p style="color: red; text-align: center">
                            {{ $t("customization_table.error_connect_server") }}
                          </p>
                        </div>
                      </div>
                      <!--  -->
                      <!-- SMTP Email -->
                      <b-card
                        no-body
                        class="mb-1"
                        v-if="show_smtp_project == showServerSetting.ShowInfo"
                      >
                        <b-card-header
                          header-tag="header"
                          class="p-1"
                          role="tab"
                        >
                          <b-button
                            block
                            v-b-toggle.accordion-3
                            variant="info"
                            >{{
                              $t("customization_table.smtp_email.title")
                            }}</b-button
                          >
                        </b-card-header>
                        <b-collapse
                          id="accordion-3"
                          accordion="my-accordion"
                          role="tabpanel"
                        >
                          <b-card-body>
                            <div class="box-body">
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="title">{{
                                    $t(
                                      "customization_table.smtp_email.email_host"
                                    )
                                  }}</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="smtp_email.email_host"
                                    :placeholder="
                                      $t(
                                        'customization_table.smtp_email.email_host'
                                      )
                                    "
                                  />
                                </div>
                              </div>

                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="title">{{
                                    $t("customization_table.smtp_email.port")
                                  }}</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="smtp_email.port"
                                    :placeholder="
                                      $t('customization_table.smtp_email.port')
                                    "
                                  />
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="title">{{
                                    $t(
                                      "customization_table.smtp_email.email_user_host"
                                    )
                                  }}</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="smtp_email.email_user_host"
                                    :placeholder="
                                      $t(
                                        'customization_table.smtp_email.email_user_host'
                                      )
                                    "
                                  />
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="title">{{
                                    $t(
                                      "customization_table.smtp_email.password_email"
                                    )
                                  }}</label>
                                  <!-- <input
                                    class="form-control"
                                    v-model="smtp_email.password_email"
                                    type="password"
                                    id="password_email"
                                    :placeholder="
                                      $t(
                                        'customization_table.smtp_email.password_email'
                                      )
                                    "
                                  /> -->
                                  <b-button
                                    class="form-control"
                                    variant="primary"
                                    @click="onShowModalChangePasswordEmailConfig"
                                  >{{$t('user.password_modal[0].title')}}</b-button>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <input
                                    type="checkbox"
                                    v-model="smtp_email.email_user_tls"
                                    :placeholder="
                                      $t(
                                        'customization_table.smtp_project.page_size'
                                      )
                                    "
                                  />
                                  <label for="title">{{
                                    $t(
                                      "customization_table.smtp_email.email_user_tls"
                                    )
                                  }}</label>
                                </div>
                              </div>
                            </div>
                            <div class="box-footer" style="padding-bottom: 0">
                              <button
                                type="button"
                                class="btn btn-labeled btn-warning"
                                style="margin-right: 5px;"
                                @click="sendTestEmail"
                              >
                                <span class="btn-label">
                                  <i class="glyphicon glyphicon-send"></i>
                                </span>
                                {{ $t("common.sendTest") }}
                              </button>
                              <button
                                type="button"
                                class="btn btn-labeled btn-success pull-right"
                                style="margin-right: 5px;"
                                @click="save_Config_SMTP_Email_Server"
                              >
                                <span class="btn-label">
                                  <i class="glyphicon glyphicon-ok"></i>
                                </span>
                                {{ $t("common.save") }}
                              </button>
                            </div>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                      <!--  -->
                    </div>
                    <!-- Media Project -->
                    <div v-if="isSuperAdmin()" class="tab-pane fade" id="tab2warning">
                      <custom-table-media
                        ref="CustomizationTable_Media"
                      ></custom-table-media>
                    </div>
                    <div class="tab-pane fade" id="tab3warning">
                      <CustomizationProjectSMTP ref="customizationProjectSMTP"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--  -->
          </div>
        </div>
      </div>
    </div>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading :active.sync="is_loading" :can-cancel="false" color="#1E90FF">
    </loading>
    <!--  -->
    <div class="modal modal-default" id="modal-change-password-smtp-server">
      <div class="modal-dialog">
        <div class="modal-content" style="top: 100px">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("user.password_modal[0].title") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="title">{{
                $t("customization_table.smtp_email.password_email")
              }}</label>
              <!-- <input
                class="form-control"
                v-model="smtp_email.password_email"
                type="password"
                id="password_email"
                :placeholder="$t('customization_table.smtp_email.password_email')"
              /> -->
              <input
                class="form-control"
                v-model="smtp_server.smtp_password"
                @input="validatePassword(smtp_server.smtp_password)"
                type="password"
                id="password"
                :placeholder="
                  $t('customization_table.smtp_server.smtp_password')
                "
              />
              <span
                :class="{
                  password_length_count: valid_password_length,
                  show_password_length: password_typed
                }"
                class="password_length"
                >{{ password_length }}</span
              >

              <!-- <div v-show="password_typed" class="lnu_container">
                <p :class="{ got_lowercase: contain_lowercase }">
                  {{ $t("user.lowercase") }}
                </p>
                <p :class="{ got_number: contain_number }">
                  {{ $t("user.digit") }}
                </p>
                <p :class="{ got_uppercase: contain_uppercase }">
                  {{ $t("user.uppercase") }}
                </p>
              </div> -->
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("confirm_email.btnClose") }}
            </button>
            <button
              type="button"
              class="btn btn-primary pull-right"
              @click="onUpdatePasswordSMTPServer"
            >
              {{ $t("confirm_email.btnConfirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <div class="modal modal-default" id="modal-change-password-email-smtp">
      <div class="modal-dialog">
        <div class="modal-content" style="top: 100px">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">{{$t('user.password_modal[0].title')}}</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label
                for="title"
              >{{$t('customization_table.smtp_email.password_email')}}</label>
              <input
                class="form-control"
                v-model="smtp_email.password_email"
                type="password"
                id="password_email"
                :placeholder="$t('customization_table.smtp_email.password_email')"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
              >{{$t('confirm_email.btnClose')}}
            </button>
            <button
              type="button"
              class="btn btn-primary pull-right"
              @click="onUpdatePasswordEmailConfig"
              >{{$t('confirm_email.btnConfirm')}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <sendTestEmailModal ref="sendEmailTesting" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import CustomizationTable_Media from "./CustomizationTable_Media.vue";
import Loading from "vue-loading-overlay";
import Enum from "../../../enum/enum";
import utils from '@/lib/utils'
import CustomizationProjectSMTP from "./CustomizationProject_SMTP.vue"
import SendTestEmailModal from "./SendTestEmailModal.vue"

// import { EventBus } from './event-bus.js';
export default {
  name: "CustomizationTable_SMTP",
  data() {
    return {
      smtpProjectList: [],
      smtp_server: {
        smtp_domain: null,
        smtp_username: "",
        smtp_password: "",
        smtp_project: null
      },
      password_length: 0,
      password_typed: false,
      // contain_lowercase: false,
      // contain_uppercase: false,
      // contain_number: false,
      valid_password_length: false,
      valid_password: false,
      smtp_project: {
        project_name: "",
        alias: "",
        page_size: null,
        sub_content: "",
        description: ""
      },
      is_loading: false,
      show_smtp_project: Enum.showServerSetting.ErrorLogin,
      showServerSetting: Enum.showServerSetting,
      notFoundProject: false,
      smtp_email: {
        email_host: null,
        email_user_host: null,
        port: null,
        password_email: null,
        email_user_tls: true
      }
    };
  },
  watch: {
    GET_SYSTEM_SMTP_CONFIG_DATA: function() {
      if (Object.keys(this.GET_SYSTEM_SMTP_CONFIG_DATA).length > 0) {
        this.smtp_server.smtp_domain = this.GET_SYSTEM_SMTP_CONFIG_DATA.smtp_domain;
        this.smtp_server.smtp_username = this.GET_SYSTEM_SMTP_CONFIG_DATA.smtp_username;
        this.smtp_server.smtp_password = "";
        this.smtp_server.smtp_project = this.GET_SYSTEM_SMTP_CONFIG_DATA.smtp_project_id;
      }
    },
    GET_SMTP_PROJECT_DATA: function() {
      this.smtp_project.project_name = this.GET_SMTP_PROJECT_DATA.project_name;
      this.smtp_project.alias = this.GET_SMTP_PROJECT_DATA.alias;
      this.smtp_project.sub_content = this.GET_SMTP_PROJECT_DATA.tail_content;
      this.smtp_project.page_size = this.GET_SMTP_PROJECT_DATA.pagination;
      this.smtp_project.description = this.GET_SMTP_PROJECT_DATA.description;
    },
    GET_CONFIG_SMTP_EMAIL_SERVER_DATA: function() {
      this.smtp_email.email_host = this.GET_CONFIG_SMTP_EMAIL_SERVER_DATA.email_host;
      this.smtp_email.email_user_host = this.GET_CONFIG_SMTP_EMAIL_SERVER_DATA.email_user_host;
      this.smtp_email.port = this.GET_CONFIG_SMTP_EMAIL_SERVER_DATA.port;
      this.smtp_email.email_user_tls = this.GET_CONFIG_SMTP_EMAIL_SERVER_DATA.email_user_tls;
      this.smtp_email.password_email = null;
    },
    GET_SMTP_PROJECT_LIST_DATA: function() {
      this.smtpProjectList = [];
      this.GET_SMTP_PROJECT_LIST_DATA.forEach(data => {
        let item = {
          id: data.id,
          project_name: data.project_name
        };
        this.smtpProjectList.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_SMTP_PROJECT_LIST_DATA",
      "GET_SYSTEM_SMTP_CONFIG_DATA",
      "GET_SNACK_BAR",
      "GET_SMTP_PROJECT_DATA",
      "GET_CONFIG_SMTP_EMAIL_SERVER_DATA",
      "GET_ACCOUNT_DATA"
    ])
  },
  methods: {
    ...mapActions([
      "GET_SMTP_PROJECT_LIST",
      "CONNECT_SMTP_CHECK_PROJECT",
      "GET_SYSTEM_SMTP_CONFIG",
      "SAVE_SYSTEM_SMTP_CONFIG",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "GET_SMTP_PROJECT",
      "PUSH_SMTP_PROJECT",
      "GET_CONFIG_SMTP_EMAIL_SERVER",
      "PUSH_CONFIG_SMTP_EMAIL_SERVER"
    ]),
    isSuperAdmin: function() {
        return utils.isSuperAdmin(this.GET_ACCOUNT_DATA);
    },
    onCheckConnect: function() {
      let filter = {
        params: {
          // smtp_domain: this.smtp_server.smtp_domain,
          // smtp_username: this.smtp_server.smtp_username,
          // smtp_password: this.smtp_server.smtp_password,
          smtpProjectId: this.smtp_server.smtp_project
        }
      };
      this.is_loading = true;
      this.CONNECT_SMTP_CHECK_PROJECT(filter)
        .then(
          function(res) {
            let mess =
              res.data.message != undefined ? res.data.message : null;
            if (mess == "project_id_is_none" || mess == "not_found_project") {
              this.notFoundProject = true;
            } else {
              this.ON_SHOW_TOAST({
                message: this.$t("common.success"),
                styleType: "success"
              });
              this.show_smtp_project = this.showServerSetting.ShowInfo;
              this.notFoundProject = false;
            }
            this.is_loading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            let mess = error.response.data.message;
            if (mess == "error_login") {
              this.show_smtp_project = this.showServerSetting.ErrorLogin;
            } else {
              this.show_smtp_project = this.showServerSetting.ErrorConnect;
            }
            this.notFoundProject = false;
            this.is_loading = false;
          }.bind(this)
        );
    },
    onSave: function() {
      let result = this.validateData();
      if (result == "OK") {
        let data = {
          // smtp_password: this.get_data_null(this.smtp_server.smtp_password),
          smtp_username: this.get_data_null(this.smtp_server.smtp_username),
          smtp_domain: this.get_data_null(this.smtp_server.smtp_domain),
          smtp_project: this.smtp_server.smtp_project
        };
        this.SAVE_SYSTEM_SMTP_CONFIG(data)
          .then(
            function(res) {
              this.SUCCESS_TOAST();
              this.GET_SYSTEM_SMTP_CONFIG();
              this.getSMTPProject();
              this.getSMTPEmailServer();
              this.GET_SMTP_PROJECT_LIST();
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
            }.bind(this)
          );
      } else if (result != "OK") {
        this.ON_SHOW_TOAST({
          message: result,
          styleType: "danger"
        });
      } else {
        this.ON_SHOW_TOAST({
          message: "This password is not valid",
          styleType: "danger"
        });
      }
    },
    get_data_null: function(data) {
      if (data === null || data === "") {
        return null;
      } else return data;
    },
    validatePassword: function(password) {
      if (password == undefined || password == "") return false;
      else this.password_length = password.length;

      if (this.password_length > 7) {
        this.valid_password_length = true;
      } else {
        this.valid_password_length = false;
      }

      if (this.password_length > 0) {
        this.password_typed = true;
      } else {
        this.password_typed = false;
      }

      // this.contain_lowercase = /[a-z]/.test(password);
      // this.contain_uppercase = /[A-Z]/.test(password);
      // this.contain_number = /\d/.test(password);

      // if (
      //   this.contain_lowercase == true &&
      //   this.contain_uppercase == true &&
      //   this.contain_number == true &&
      //   this.valid_password_length == true
      // ) {
      //   this.valid_password = true;
      // } else {
      //   this.valid_password = false;
      // }
      this.valid_password = true;
      return this.valid_password;
    },
    validateData: function() {
      let validatedResult = "OK";
      if (
        this.smtp_server.smtp_domain != null &&
        this.smtp_server.smtp_domain != ""
      ) {
        // if (this.validatePassword(this.smtp_server.smtp_password) === false) {
        //   validatedResult = "This password is not valid";
        // }
        for (let key in this.smtp_server) {
          if (key === "smtp_project" || key === "smtp_password") {
            //
          } else if (
            this.smtp_server[key] === null ||
            this.smtp_server[key] === ""
          ) {
            validatedResult =
              "Vui Lòng Nhập: " +
              this.$t("customization_table.smtp_server." + key);
            break;
          } else {
            //
          }
        }
      }
      return validatedResult;
    },
    onSave_SMTP_Project: function() {
      if (this.smtp_project.page_size <= 0) {
        this.ON_SHOW_TOAST({
          message: "Page size not validate",
          styleType: "danger"
        });
      } else {
        let data = {
          // smtpServiceKey: null,
          project_name: utils.getCleanStringValue(this.smtp_project.project_name),
          alias: utils.getCleanStringValue(this.smtp_project.alias),
          page_size: this.smtp_project.page_size,
          sub_content: utils.getCleanStringValue(this.smtp_project.sub_content),
          description: utils.getCleanStringValue(this.smtp_project.description)
        };
        this.PUSH_SMTP_PROJECT(data)
          .then(
            function(res) {
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
            }.bind(this)
          );
      }
    },
    getMediaInfo: function() {
      this.$refs.CustomizationTable_Media.getEventFromSMTP();
    },
    getSMTPProject: function() {
      this.is_loading = true;
      let filter = {
        params: {
          // smtpServiceKey: null
        }
      };
      this.GET_SMTP_PROJECT(filter)
        .then(
          function(res) {
            let message =
              res.data.message != undefined ? res.data.message : null;
            if (
              message == "project_id_is_none" ||
              message == "not_found_project"
            ) {
              this.notFoundProject = true;
            } else {
              this.show_smtp_project = this.showServerSetting.ShowInfo;
              this.notFoundProject = false;
            }
            this.is_loading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            let mess = error.response.data.message;
            if (mess == "error_login") {
              this.show_smtp_project = this.showServerSetting.ErrorLogin;
            } else {
              this.show_smtp_project = this.showServerSetting.ErrorConnect;
            }
            this.notFoundProject = false;
            this.is_loading = false;
          }.bind(this)
        );
    },
    // SMTP Email Server
    getSMTPEmailServer: function() {
      this.is_loading = true;
      let filter = {
        params: {
          // smtpServiceKey: this.tabSelect
        }
      };
      this.GET_CONFIG_SMTP_EMAIL_SERVER(filter)
        .then(
          function(res) {
            let message =
              res.data.message != undefined ? res.data.message : null;
            if (
              message == "project_id_is_none" ||
              message == "not_found_project"
            ) {
              this.notFoundProject = true;
            } else {
              this.show_smtp_project = this.showServerSetting.ShowInfo;
              this.notFoundProject = false;
            }
            this.is_loading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            let mess = error.response.data.message;
            if (mess == "error_login") {
              this.show_smtp_project = this.showServerSetting.ErrorLogin;
            } else if (
              mess == "project_id_is_none" ||
              mess == "not_found_project"
            ) {
              this.notFoundProject = true;
            } else {
              this.show_smtp_project = this.showServerSetting.ErrorConnect;
            }
            this.notFoundProject = false;
            this.is_loading = false;
          }.bind(this)
        );
    },
    validateData_SMTP_Email: function() {
      let validatedResult = "OK";
      for (let key in this.smtp_email) {
        if (key === 'password_email') {
          // 
        } else if (this.smtp_email[key] === null || this.smtp_email[key] === "") {
          validatedResult =
            "Vui Lòng Nhập: " +
            this.$t("customization_table.smtp_email." + key);
          break;
        } else {
          //
        }
      }
      return validatedResult;
    },
    save_Config_SMTP_Email_Server: function() {
      let result = this.validateData_SMTP_Email();
      if (result == "OK") {
        this.is_loading = true;
        let data = {
          // smtpServiceKey: null,
          email_host: utils.getCleanStringValue(this.smtp_email.email_host),
          email_user_host: utils.getCleanStringValue(this.smtp_email.email_user_host),
          email_user_tls: utils.getCleanStringValue(this.smtp_email.email_user_tls),
          port: utils.getCleanStringValue(this.smtp_email.port)
        };
        this.PUSH_CONFIG_SMTP_EMAIL_SERVER(data)
          .then(
            function(res) {
              this.SUCCESS_TOAST();
              this.getSMTPEmailServer();
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
            }.bind(this)
          );
      } else {
        this.ON_SHOW_TOAST({
          message: result,
          styleType: "danger"
        });
      }
    },
    sendTestEmail: function () {
      this.$refs.sendEmailTesting.onShowModal(null)
    },
    onShowModalChangePasswordEmailConfig: function () {
      $("#modal-change-password-email-smtp").modal("show");
      this.smtp_email.password_email = null
    },
    onUpdatePasswordEmailConfig: function () {
      if(utils.isEmptyString(this.smtp_email.password_email)) {
        this.ON_SHOW_TOAST({
          message: this.$t('customization_table.smtp_email.password_email'),
          styleType: "danger"
        });
      } else {
        this.is_loading=true;
        let data = {
          // smtpServiceKey: null,
          email_host: utils.getCleanStringValue(this.smtp_email.email_host),
          email_user_host: utils.getCleanStringValue(this.smtp_email.email_user_host),
          password_email: utils.getCleanStringValue(this.smtp_email.password_email),
          email_user_tls: utils.getCleanStringValue(this.smtp_email.email_user_tls),
          port: utils.getCleanStringValue(this.smtp_email.port)
        };
        this.PUSH_CONFIG_SMTP_EMAIL_SERVER(data)
          .then(
            function(res) {
              this.SUCCESS_TOAST();
              $("#modal-change-password-email-smtp").modal("hide");
              this.getSMTPEmailServer()
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
            }.bind(this)
          );
      }
    },
    onClickGetDataTab: function(index) {
      switch (index) {
        case 1:
          this.$refs.ConfigSidebarList.getDataConfigSideBarList();
          break;
      }
    },
    onShowModalChangePasswordSMTPServer: function() {
      $("#modal-change-password-smtp-server").modal("show");
      this.smtp_server.smtp_password = null;
      this.validatePassword(this.smtp_server.smtp_password);
    },
    onCloseModalChangePasswordSMTPServer: function() {
      $("#modal-change-password-smtp-server").modal("hide");
    },
    onUpdatePasswordSMTPServer: function() {
      if (this.validatePassword(this.smtp_server.smtp_password) === false) {
        this.ON_SHOW_TOAST({
          message: this.$t("common.password_not_valid"),
          styleType: "danger"
        });
      } else {
        let data = {
          smtp_password: utils.getCleanStringValue(this.smtp_server.smtp_password)
        };
        this.SAVE_SYSTEM_SMTP_CONFIG(data)
          .then(
            function(res) {
              this.SUCCESS_TOAST();
              this.onCloseModalChangePasswordSMTPServer()
              this.GET_SYSTEM_SMTP_CONFIG();
              this.getSMTPProject();
              this.getSMTPEmailServer();
              this.GET_SMTP_PROJECT_LIST();
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
            }.bind(this)
          );
      }
    },
    onSelectTab: function(value) {
      switch (value) {
        case 1:
          this.GET_SMTP_PROJECT_LIST();
          this.GET_SYSTEM_SMTP_CONFIG();
          this.getSMTPProject();
          this.getSMTPEmailServer();
          break;
        case 2:
          this.getMediaInfo()
          break;

        case 3:
          this.$refs.customizationProjectSMTP.onGetData()
          break;

        default:
          break;
      }
    }
  },
  mounted() {
    this.GET_SMTP_PROJECT_LIST();
    this.GET_SYSTEM_SMTP_CONFIG();
    this.getSMTPProject();
    this.getSMTPEmailServer();
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    "custom-table-media": CustomizationTable_Media,
    loading: Loading,
    CustomizationProjectSMTP,
    SendTestEmailModal
  }
};
</script>

<style scoped>
.panel.with-nav-tabs .panel-heading {
  padding: 5px 5px 0 5px;
}
.panel.with-nav-tabs .nav-tabs {
  border-bottom: none;
}
.panel.with-nav-tabs .nav-justified {
  margin-bottom: -1px;
}
/********************************************************************/
/*** PANEL WARNING ***/
.with-nav-tabs.panel-warning .nav-tabs > li > a,
.with-nav-tabs.panel-warning .nav-tabs > li > a:hover,
.with-nav-tabs.panel-warning .nav-tabs > li > a:focus {
  color: #8a6d3b;
}
.with-nav-tabs.panel-warning .nav-tabs > .open > a,
.with-nav-tabs.panel-warning .nav-tabs > .open > a:hover,
.with-nav-tabs.panel-warning .nav-tabs > .open > a:focus,
.with-nav-tabs.panel-warning .nav-tabs > li > a:hover,
.with-nav-tabs.panel-warning .nav-tabs > li > a:focus {
  color: #8a6d3b;
  background-color: #faebcc;
  border-color: transparent;
}
.with-nav-tabs.panel-warning .nav-tabs > li.active > a,
.with-nav-tabs.panel-warning .nav-tabs > li.active > a:hover,
.with-nav-tabs.panel-warning .nav-tabs > li.active > a:focus {
  color: #8a6d3b;
  background-color: #fff;
  border-color: #faebcc;
  border-bottom-color: transparent;
}
.with-nav-tabs.panel-warning .nav-tabs > li.dropdown .dropdown-menu {
  background-color: #fcf8e3;
  border-color: #faebcc;
}
.with-nav-tabs.panel-warning .nav-tabs > li.dropdown .dropdown-menu > li > a {
  color: #8a6d3b;
}
.with-nav-tabs.panel-warning
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > li
  > a:hover,
.with-nav-tabs.panel-warning
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > li
  > a:focus {
  background-color: #faebcc;
}
.with-nav-tabs.panel-warning
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a,
.with-nav-tabs.panel-warning
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a:hover,
.with-nav-tabs.panel-warning
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a:focus {
  color: #fff;
  background-color: #8a6d3b;
}
/*  */
.lnu_container {
  display: block;
  margin: 10px auto;
  margin-bottom: 0;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
}
.lnu_container p {
  width: 30%;
  height: auto;
  font-size: 12px;
  line-height: 1.2;
  text-align: center;
  border-radius: 2px;
  color: rgba(71, 87, 98, 0.8);
  background: linear-gradient(to right, #06a65a 50%, #eee 50%);
  background-size: 200% 100%;
  background-position: right;
  -webkit-transition: background 0.3s;
  transition: background 0.3s;
}
.got_lowercase,
.got_uppercase,
.got_number {
  background-position: left !important;
  color: rgba(255, 255, 255, 0.9) !important;
}
.show_password_length {
  display: block !important;
}
.password_length {
  padding: 2px 8px;
  position: absolute;
  top: 57px;
  right: 21px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  background: #dd4b39;
  color: white;
  border-color: #d73925;
  border-radius: 4px;
  font-size: 13px;
  display: none;
  -webkit-transition: all 0.1s;
  transition: all 0.1s;
}
.password_length_modal {
  padding: 2px 8px;
  position: absolute;
  top: 50.3%;
  right: 21px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  background: #dd4b39;
  color: white;
  border-color: #d73925;
  border-radius: 4px;
  font-size: 13px;
  display: none;
  -webkit-transition: all 0.1s;
  transition: all 0.1s;
}
.password_length_count {
  background: #06a65a;
  color: rgba(255, 255, 255, 0.9);
}
/*  */
/* .row {
  margin-top: 40px;
  padding: 0 10px;
}

.clickable {
  cursor: pointer;
}

.panel-heading span {
  margin-top: -20px;
  font-size: 15px;
} */
</style>



// WEBPACK FOOTER //
// src/views/Project/CustomizationTable_SMTP.vue